import React from "react";
import "../../../AllComponentCSS.css";

function JS_reduce() {
  return (
    <div className="tutorial-page">
      <h1>JS reduce</h1>
      <p>This page will cover the reduce topic in detail.</p>
    </div>
  );
}

export default JS_reduce;
